import CookiesPreferences from './CookiesPreferences';

function DisclaimerAndPolicyPage(): JSX.Element {
  return (
    <div className="DisclaimerPage">
      <h1>Terms and Policies</h1>
      <h2>Disclaimer – Information Accuracy</h2>
      <p>
        The information provided on this website about restaurants, places, and sightseeing attractions is based on the most recent data at the time of publication. However, due to the dynamic nature
        of the hospitality and tourism industries, details such as menus, prices, operating hours, and availability may change without notice.
      </p>

      <p>We are committed to regularly review and update content wherever possible to provide the best experience possible.</p>

      <p>
        We recommend that readers verify key details directly with the respective businesses or locations before planning their visits. The website assumes no responsibility for inaccuracies or
        inconveniences resulting from outdated information.
      </p>

      <h2>Cookies Policy 🍪</h2>
      <p>
        Our website uses essential cookies to ensure its proper functionality. These cookies are necessary for the website to work, and they cannot be disabled. They include session cookies, which
        help maintain your session as you navigate the site, and CSRF cookies, which protect against cross-site request forgery attacks.
      </p>

      <p>
        In addition to essential cookies, we may also use optional cookies for analytics, performance monitoring, advertising, and third-party services. These help us improve your experience and
        deliver relevant content, but they are not strictly necessary for the website to operate.
      </p>

      <CookiesPreferences />
    </div>
  );
}

export default DisclaimerAndPolicyPage;
